import ReactModal from 'react-modal';
import { RoleTag } from '../pages/person/RoleTag';
import General from '../utils/GeneralUtils';
import './EmailVerificationSlideout.scss';
import './DecisionLevelSlideout.scss';

const DECISION_LEVELS = [
  {
    value: 'executive',
    label: 'Executive',
    color: 'green',
    description: 'Top-level decision makers who set district-wide strategy and policy.',
    examples: 'Superintendent, Assistant Superintendent, Chief Officers',
  },
  {
    value: 'functional leader',
    label: 'Functional Leader',
    color: 'green',
    description: 'Leaders who oversee specific departments or functional areas.',
    examples: 'Director of Technology, Director of HR, Director of Finance',
  },
  {
    value: 'school leadership',
    label: 'School Leadership',
    color: 'blue',
    description: 'Building-level leaders responsible for school operations and staff.',
    examples: 'Principal, Assistant Principal, Dean',
  },
  {
    value: 'operational support',
    label: 'Operational Support',
    color: 'yellow',
    description: 'Staff who coordinate programs, manage processes, or provide specialized support.',
    examples: 'Coordinator, Specialist, Supervisor',
  },
  {
    value: 'practitioner',
    label: 'Practitioner',
    color: 'yellow',
    description: 'Frontline staff who directly deliver services or instruction.',
    examples: 'Teacher, Counselor, Librarian, Nurse',
  },
];

interface DecisionLevelSlideoutProps {
  isOpen: boolean;
  onClose: () => void;
}

export function DecisionLevelSlideout({ isOpen, onClose }: DecisionLevelSlideoutProps) {
  return (
    <ReactModal
      isOpen={isOpen}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      onRequestClose={onClose}
      style={General.getSliderDefaults({ width: 'min(90vw, 450px)' })}
      parentSelector={General.getModalRoot}
    >
      <div className="email-verification-slideout">
        <div className="header">
          <h3>Decision Level</h3>
        </div>

        <div className="section intro">
          <p>Decision Level indicates where a role sits in the organizational hierarchy and the scope of decision-making authority.</p>
        </div>

        <div className="section">
          <div className="decision-level-list">
            {DECISION_LEVELS.map((level) => (
              <div key={level.value} className="decision-level-item">
                <RoleTag type="decisionLevel" value={level.label} size="small" />
                <p className="decision-level-item__description">{level.description}</p>
                <p className="desc-2" style={{ marginTop: 0 }}>e.g., {level.examples}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </ReactModal>
  );
}
